import { useLocation, useNavigate } from "react-router-dom";

import useWindowSize from "../../hooks/useWindowSize";
import { useAppSelector } from "../../redux/store";
import "../../layout/Leftnav/leftnav.scss";

export default function NavLink({
  label,
  path,
  icon,
  expandIcon,
  onClick,
  hash,
  method,
  className,
  level,
}: {
  label?: string;
  path: string;
  icon?: React.ReactNode;
  expandIcon?: React.ReactNode;
  onClick?: () => void;
  hash?: string;
  method?: string;
  className?: string;
  level?: "first" | "second" | "third";
}) {
  const { isCollapsed } = useAppSelector((state) => state.sidebar);

  const { width } = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive =
    location.pathname === path ||
    location.pathname === `${path}/create` ||
    location.pathname === `${path}/edit` ||
    location.pathname === `${path}/view`;

  return (
    <div
      onClick={(e) => {
        navigate(path);
        if (onClick) onClick();
      }}
      className={`py-1 nav-link-item ${className ?? ""} ${isCollapsed ? "collapsed-menu" : ""} ${level === "third" ? "third-level-navlink" : ""}`}
      id={path}
    >
      <div
        className={` ${isActive ? "link active" : ""} ${isCollapsed ? "w-90" : "w-100"}`}
        id="navlink"
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex">
            {isActive && (
              <div
                className={`${width < 992 ? "thick-line-medium-screen" : "thick-line"}`}
              ></div>
            )}
            <div
              className={
                isActive
                  ? `side-header side-header-active ${level === "third" && width < 992 ? "leftnav-md-third-level-active" : ""}`
                  : `side-header ms-3 ${level === "third" && (!method ? "" : "ms-2")} ${level === "third" && width < 992 ? "ms-4 ps-2" : ""}`
              }
            >
              {icon}

              {!isCollapsed && label}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
